import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// 경로 → page 이름 매핑
const PAGE_MAP = {
    '/': 'home',
    '/timetable': 'timetable',
    '/daily': 'daily',
    '/timer': 'timer',
    '/statistics': 'statistics',
    '/subjects': 'subjects',
    '/recurring': 'recurring',
    '/observer': 'observer',
    '/studyroom': 'studyroom',
    '/admin': 'admin',
    '/announcements': 'announcements',
    '/personalinfo': 'personalinfo',
    '/about': 'about',
    '/privacy': 'privacy',
    '/ai-usage': 'ai-usage',
    '/login': 'login',
    '/register': 'register'
};

function getPageName(pathname) {
    return PAGE_MAP[pathname] || null;
}

export function usePageTracking() {
    const location = useLocation();
    const lastPage = useRef(null);

    useEffect(() => {
        const page = getPageName(location.pathname);
        if (!page) return;

        // 같은 페이지 중복 전송 방지
        if (lastPage.current === page) return;
        lastPage.current = page;

        // fire-and-forget
        fetch(`${API_URL}/api/v1/activity/pageview`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ page })
        }).catch(() => {});
    }, [location.pathname]);
}

/**
 * 탭 전환 추적 (Admin 등 탭이 있는 페이지에서 사용)
 */
export function trackTabView(page, tab) {
    if (!page || !tab) return;
    fetch(`${API_URL}/api/v1/activity/pageview`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ page, tab })
    }).catch(() => {});
}
